import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import { Provider } from "react-redux";
import store from "./redux/store";
import { init } from "./clients/analytics/mixpanel";

import { BrowserRouter } from "react-router-dom";
import Auth0ProviderWithHistory from "./clients/auth/Auth0ProviderWithHistory";
import "./scripts/index.js";
import "./styles/index.js";

// initialise mixpanel
init();

// Disable console.log in production
if (process.env.REACT_APP_DISABLE_CONSOLE_LOG === 'true') {
  const noop = () => {};
  
  // Override console methods
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  
  // Keep error and warn for critical issues
  // console.error = noop;
  // console.warn = noop;
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithHistory>
        <Provider store={store}>
          <App />
        </Provider>
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//import reportWebVitals from "./reportWebVitals";
// reportWebVitals();
